import React from 'react';
import { Alert } from '@zooplus/ui-components';
import { useTranslation } from 'react-i18next';
import { useLivechat } from '../hooks/useLivechat';

const LivechatInfoSection: React.FC = () => {
  const { t } = useTranslation();

  useLivechat();

  return (
    <div data-test="livechatSection.container" className="livechatSection">
      <Alert closeButtonAriaLabel="Notification title">
        <div className="livechatSection__alert">
          <div className="livechatSection__alert--description">
            {t('header.livechat_description')}
          </div>
          <div className="livechatSection__alert--ai-assistant" id="ai-assistant" />
        </div>
      </Alert>
    </div>
  );
};
export default LivechatInfoSection;
